import React from 'react';
import { Modal, Button, Badge, Spinner } from 'react-bootstrap';
import { AdministrativeServiceData, administrativeService } from 'src/utils/administrativeServiceUtils.js';

const ACCION_LABELS = {
    'POST':   'Enviado',
    'DELETE': 'Borrado',
};

const fieldRow = (label, value) => (
    <div className='d-flex py-1 border-bottom'>
        <span className='mr-3' style={{ minWidth: '180px', fontWeight: 600 }}>{label}</span>
        <span>{value}</span>
    </div>
);

const jsonBlock = (value) => {
    if (!value) return <span className='text-muted'>—</span>;
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        return (
            <pre className='mb-0' style={{ fontSize: '0.8rem', maxHeight: '300px', overflowY: 'auto', background: '#f8f9fa', padding: '10px', borderRadius: '4px' }}>
                {JSON.stringify(parsed, null, 2)}
            </pre>
        );
    } catch {
        return <pre className='mb-0' style={{ fontSize: '0.8rem', maxHeight: '300px', overflowY: 'auto', background: '#f8f9fa', padding: '10px', borderRadius: '4px' }}>{value}</pre>;
    }
};

const TreasuryAuditDetailModal = ({ show, handleClose, detailData, isFetching }) => {

    const administrativeServiceData = AdministrativeServiceData();
    const isError = detailData?.statusCode && detailData.statusCode >= 400;

    return (
        <Modal show={show} onHide={handleClose} size='lg' centered>
            <Modal.Header closeButton>
                <Modal.Title className='h5'>
                    Detalle de la auditoría de Tesorería General
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isFetching && (
                    <div className='text-center py-4'>
                        <Spinner animation='border' variant='primary' size='sm' className='mr-2' />
                        Cargando detalle...
                    </div>
                )}
                {!isFetching && !detailData && (
                    <p className='text-muted text-center'>Sin datos disponibles.</p>
                )}
                {!isFetching && detailData && (
                    <>
                        <div className='mb-4'>
                            {fieldRow('Fecha', detailData.createdDate?.split(' ')[0] ?? '—')}
                            {fieldRow('Hora', detailData.createdDate?.split(' ')[1] ?? '—')}
                            {fieldRow('Acción',
                                <Badge variant={detailData.accion === 'DELETE' ? 'danger' : 'primary'}>
                                    {ACCION_LABELS[detailData.accion] ?? detailData.accion ?? '—'}
                                </Badge>
                            )}
                            {fieldRow('Estado',
                                <Badge variant={isError ? 'danger' : 'success'}>
                                    {isError ? 'No se completó' : 'OK'}
                                </Badge>
                            )}
                            {fieldRow('Pedido de Fondos', detailData.pf ?? '—')}
                            {fieldRow('Servicio Administrativo',
                                administrativeService(detailData.administrativeServiceId, administrativeServiceData ?? []) || '—'
                            )}
                        </div>

                        <h6 className='mt-3 mb-1'><b>Payload enviado</b></h6>
                        <div className='mb-3'>{jsonBlock(detailData.requestBody)}</div>

                        <h6 className='mt-3  mb-1'><b>Respuesta recibida</b></h6>
                        <div className={isError ? 'mb-3' : ''}>{jsonBlock(detailData.responseBody)}</div>

                        {isError && (
                            <>
                                <h6 className='text-danger mb-1'>Detalle del error</h6>
                                <div>{jsonBlock(detailData.errorDetail ?? detailData.errorMessage)}</div>
                            </>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' size='sm' onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TreasuryAuditDetailModal;
